import Swal from 'sweetalert2'
import {TOKEN_NAME} from "@/services/ConstantService";

export const AlertService = {
  initializeSwal () {
    window.swal = Swal

    window.confirmCreateAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-warning font-weight-bolder mr-2',
        cancelButton: 'btn btn-outline-secondary font-weight-bolder'
      },
      buttonsStyling: false
    })

    window.confirmUpdateAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-warning font-weight-bolder mr-2',
        cancelButton: 'btn btn-outline-secondary font-weight-bolder'
      },
      buttonsStyling: false
    })

    window.deleteAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder mr-2',
        cancelButton: 'btn btn-outline-secondary font-weight-bolder'
      },
      buttonsStyling: false
    })

    window.serverErrorAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder mr-2'
      },
      buttonsStyling: false
    })

    window.successAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success font-weight-bolder mr-2'
      },
      buttonsStyling: false
    })

    window.errorAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder mr-2'
      },
      buttonsStyling: false,
      allowOutsideClick: false
    })

    window.cancelAlert = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-sm btn-primary mr-2',
        cancelButton:  'btn btn-sm btn-danger'
      },
      buttonsStyling: false
    })

    window.companyInstructionSend = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success font-weight-bolder mr-2',
        cancelButton: 'btn btn-outline-secondary font-weight-bolder'
      },
      icon: 'question',
      buttonsStyling: false
    })

    window.companyInstructionCancel = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder mr-2',
        cancelButton: 'btn btn-outline-secondary font-weight-bolder'
      },
      icon: 'question',
      buttonsStyling: false
    })

    window.systemUpdateModal = Swal.mixin({
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      customClass: 'swal-wide'
    })
  },

  serverErrorAlert (message) {
    // eslint-disable-next-line no-undef
    serverErrorAlert.fire({
      title: 'SERVER ERROR',
      text: `ERROR ON ${message}`,
      footer: '<a href="mailto:albert.arbowez@elitesdsi.com">PLEASE CONTACT SYSTEM ADMINISTRATOR</a>',
      scrollbarPadding: false
    })
  },

  loading () {
    Swal.fire({
      title: 'Please Wait . . . .',
      imageWidth: 100,
      imageHeight: 50,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      scrollbarPadding: false
    })
  },

  async confirmCreateAlert (message , confirmButtonText = 'Yes, add it!' , title = 'ADD RECORD') {
    if (!message) message = 'Are you sure you want to add this record?'
    // eslint-disable-next-line no-undef
    return await confirmCreateAlert.fire({
      title: title,
      text: message,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      scrollbarPadding: false
    }).then((result) => {
      return result.value
    })
  },

  async confirmImportAlert (message) {
    if (!message) message = 'Are you sure you want to import this file?'
    // eslint-disable-next-line no-undef
    return await confirmCreateAlert.fire({
      title: 'IMPORT FILE',
      text: message,
      showCancelButton: true,
      confirmButtonText: 'Yes, import it!',
      scrollbarPadding: false
    }).then((result) => {
      return result.value
    })
  },

  async confirmUpdateAlert (message,confirmButtonText='Yes, update it!') {
    if (!message) message = 'Are you sure you want to update this record?'
    // eslint-disable-next-line no-undef
    return await confirmUpdateAlert.fire({
      title: 'CONFIRM UPDATE',
      text: message,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      scrollbarPadding: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    }).then((result) => {
      return result.value
    })
  },

  async confirmDeleteAlert (title, message, confirmBtnMsg) {
    if (!title) title = 'CONFIRM DELETION'
    if (!message) message = 'Are you sure you want to delete this record?'
    if (!confirmBtnMsg) confirmBtnMsg = 'Are you sure you want to delete this record?'
    // eslint-disable-next-line no-undef
    return await deleteAlert.fire({
      title: title,
      text: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmBtnMsg,
      scrollbarPadding: false
    }).then((result) => {
      return result.value
    })
  },

  async cancelAlert (){
    return await cancelAlert.fire({
      title:'Confirm Cancel',
      text: 'Do you want to cancel?',
      type: 'question',
      showCancelButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      allowEnterKey:false,
    }).then((result) => {
      return result.value
    })
  },

  async cancelChanges (){
    return await cancelAlert.fire({
      title:'YOU HAVE UNSAVED CHANGES',
      text: 'Are you sure you want to Leave without Saving? Any Unsaved Progress will be Lost.',
      type: 'question',
      showCancelButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      allowEnterKey:false,
    }).then((result) => {
      return result.value
    })
  },

  successAlert (message, actionType, timer = 1500) {
    // eslint-disable-next-line no-undef
    successAlert.fire({
      title: `${actionType} SUCCESS`,
      text: message,
      showConfirmButton: true,
      timer: timer,
      scrollbarPadding: false
    })

    return message;
  },

  async companyInstructionAlertSend (message = 'Do yo want to send company instruction'){
    return await companyInstructionSend.fire({
      title:`Send Company Instruction`,
      text:  message,
      type: 'question',
      showCancelButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      allowEnterKey:false,
    }).then((result) => {
      return result.value
    })
  },

  async companyInstructionAlertCancel (message = 'Do yo want to cancel company instruction'){
    return await companyInstructionCancel.fire({
      title:`Cancel Company Instruction`,
      text:  message,
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      allowEnterKey:false,
    }).then((result) => {
      return result.value
    })
  },

  errorAlert (message, actionType, timer = 3000) {
    const hasToken = localStorage.getItem(TOKEN_NAME);
    if (!hasToken) {
      return false;
    }
    swal.close();

    // eslint-disable-next-line no-undef
    errorAlert.fire({
      title: `${actionType.toUpperCase()} FAILED`,
      html: message,
      showConfirmButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      scrollbarPadding: false,
      timer : timer
    });
  },

  warningAlert (message, actionType) {
    // actionType = actionType + "";
    swal.close();
    // eslint-disable-next-line no-undef
    errorAlert.fire({
      title: `${actionType.toUpperCase()} WARNING`,
      html: message,
      type: 'warning',
      showConfirmButton: true,
      allowOutsideClick:false,
      allowEscapeKey:false,
      scrollbarPadding: false
    })
  },

  async duplicateAuditorAlert(message) {
    return await confirmCreateAlert.fire({
      title: 'DUPLICATE AUDITOR',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      scrollbarPadding: false
    }).then(result => result.value);
  },
}
